import {createFileRoute} from '@tanstack/react-router';
import {ConfigPage} from 'pages';

export const Route = createFileRoute('/config')({
  component: ConfigPage,
});
